import * as React from 'react';

import {
  type UsStateConfig,
  type UsTerritoryConfig,
} from '@dnc/baseline/contentful/types';
import type { Jurisdiction } from '@dnc/baseline/data/jurisdictions';
import type { Option } from '@dnc/baseline/utils/option';

import PageLayout from '../PageLayout';
import { type Alerts } from '../SiteBanners';

import IwvLayout from './IwvLayout';

/**
 * Boilerplate component to combine {@link PageLayout} and {@link IwvLayout}
 * together to render the standard 2-column IWV page.
 */
export default function IwvPage({
  alerts,
  jurisdiction,
  localeConfig: jurisdictionLocaleConfig,
  hotlineFooterConfig: jurisdictionHotlineConfig,
  children,
}: {
  jurisdiction: Option<Jurisdiction>;
  localeConfig: Option<
    Pick<
      UsStateConfig | UsTerritoryConfig,
      'priorityLocales' | 'supportedLocales'
    >
  >;

  hotlineFooterConfig: Option<
    Pick<UsStateConfig, 'hotlineFooterOverride' | 'voterHotline'>
  >;
  alerts: Alerts;
  children: React.ReactNode;
}): React.ReactNode {
  return (
    <PageLayout
      alerts={alerts}
      hotlineFooterOverride={jurisdictionHotlineConfig?.hotlineFooterOverride}
      priorityLocales={jurisdictionLocaleConfig?.priorityLocales}
      supportedLocales={jurisdictionLocaleConfig?.supportedLocales}
    >
      <IwvLayout
        jurisdiction={jurisdiction}
        customVoterHotline={jurisdictionHotlineConfig?.voterHotline}
        hotlineFooterOverride={jurisdictionHotlineConfig?.hotlineFooterOverride}
      >
        {children}
      </IwvLayout>
    </PageLayout>
  );
}
